// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1FfcZ","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3rDOM"};